export const wait = async (waitMillSec: number) =>
  await new Promise((resolve) => setTimeout(resolve, waitMillSec));
